<template>
  <div class="has-background-white">
    <div class="columns is-hidden-mobile">
      <div class="column is-10">
        <figure class="image">
          <img src="@/assets/logo.png" alt />
        </figure>
      </div>
    </div>
    <div class="nav-links">
      <router-link to="/dashboard" active-class="is-active">
        <span class="icon is-medium">
          <font-awesome-icon icon="home" size="2x"></font-awesome-icon>
        </span>
        <span>Dashboard</span>
      </router-link>
      <router-link to="/user" active-class="is-active">
        <span class="icon is-medium">
          <font-awesome-icon icon="user" size="2x"></font-awesome-icon>
        </span>
        <span>Users</span>
      </router-link>
      <router-link to="/request" active-class="is-active">
        <span class="icon is-medium">
          <font-awesome-icon
            icon="clipboard-list"
            size="2x"
          ></font-awesome-icon>
        </span>
        <span>Requests</span>
      </router-link>
      <router-link
        to="/report"
        active-class="is-active"
        v-if="role !== 'engineer'"
      >
        <span class="icon is-medium">
          <font-awesome-icon icon="chart-bar" size="2x"></font-awesome-icon>
        </span>
        <span>Reports</span>
      </router-link>
      <router-link
        to="/export"
        active-class="is-active"
        v-if="role !== 'engineer'"
      >
        <span class="icon is-medium">
          <font-awesome-icon icon="download" size="2x"></font-awesome-icon>
        </span>
        <span>Export</span>
      </router-link>
      <router-link to="/logout" active-class="is-active">
        <span class="icon is-medium">
          <font-awesome-icon icon="sign-out-alt" size="2x"></font-awesome-icon>
        </span>
        <span>Logout</span>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    role() {
      return localStorage.getItem("role");
    }
  }
};
</script>
<style lang="scss" scoped>
.image {
  padding-left: 14px;
}
.nav-links {
  display: flex;
  flex-direction: row;
  @include from($tablet) {
    flex-direction: column;
    padding: 0;
  }
  a {
    display: flex;
    flex-direction: column;
    flex-basis: 0;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: $grey;
    transition: color 0.2s ease-in-out;
    padding-top: 18px;
    .icon {
      transform: scale(0.7);
    }
    span:last-of-type {
      margin-top: 4px;
      font-size: 12px;
    }
    &.is-active {
      color: $link;
    }
    @include from($tablet) {
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 12px 4px;
      border-bottom: 1px solid $white-ter;
      &:first-of-type {
        border-top: 1px solid $white-ter;
      }
      .icon {
        transform: scale(0.5);
      }
      span:last-of-type {
        margin-left: 8px;
        font-size: 18px;
      }
    }
  }
}
</style>
